<template>

  <!-- <vue-drag-resize  class="scorePoint" :class="{quickScore: type==100}" :isActive="false" :isDraggable="isDraggable" :isResizable="isResizable" :w="w" @resizestop="resizeStop" @activated="activateEv"
                   :h="h" :x="x" :y="y" :minw="1" :minh="1"  v-on:resizing="resize" v-on:dragging="resize" @clicked.prevent="myClick" @deactivated="deactivateEv"> -->
  <vue-drag-resize   class="scorePoint"  :class="{quickScore: type==100}" :isActive="false"  :isDraggable="isDraggable"  :isResizable="isResizable" 
      :w="w" 
      :h="h" 
      :x="x" 
      :y="y" 
      :minw="1" 
      :minh="1"  
      @resizestop="resizeStop"  
      @dragstop="dragstop"     
      @activated="activateEv"
      v-on:resizing="resize"  
      v-on:dragging="dragging"  
      @deactivated="deactivateEv" 
      @mousedown.native="onMyMouseDown"
      @mouseup.native="onMyMouseUp"
    >
    <div @mouseover="showDelete(true)" @mouseout="showDelete(false)">
      <div class="div-del" :class="{'div-del2': (type==12), 'div-del4': (type==4), 'div-del-inner': (type==3 || type==14 || type==16)}" v-show="isShowDelete">
        <!-- <i class="el-icon-delete" v-if="(type==3 || type==14 || type==16)" style="display: inline; color: blue;" @click.stop="deleteMe"></i>
        <i class="el-icon-error" v-else style="display: inline; color: yellow;" @click.stop="deleteMe"></i> -->
        <i class="el-icon-error" v-if="type!=99" style="display: inline; color: red;" @click.stop="deleteMe"></i>
      </div>

      <!-- 打钩 -->
      <div class="check" v-if="type==1" :style="{ '--myColor': myColor}"></div>
      <!-- 半对 -->
      <div class="check-hard" v-if="type==11" :style="{'--myColor': myColor}"></div>
      <!-- × -->
      <div class="tick-error" v-if="type==2" :style="{'--myColor': myColor}"></div>
      <!-- 横线 -->
      <div class="yi" v-if="type==12" :style="{ '--myColor': myColor}"></div>
      <!-- 圆形 -->
      <div class="ellipse" :style="{width: w+'px', height: h+'px', '--myColor': myColor}" v-if="type==3"></div>
      <!-- 矩形 -->
      <div class="juxing" :style="{width: w+'px', height: h+'px', '--myColor': myColor}" v-if="type==14"></div>
      <!-- 问号 -->
      <div class="wenhao" v-if="type==15" :style="{color: myColor, '--myColor': myColor}">?</div>
      <!-- 省略号 -->
      <div class="shenglue" v-if="type==16" :style="{color: myColor, '--myColor': myColor}">...</div>
      <!-- 文字 -->
      <div class="wenzi" v-if="type==4" :style="{'--myColor': myColor}">
        <el-input v-model="wenziText" ref="drag-search" placeholder="" @blur="weiziChange" :style="textStyle" class="wenziTyle"></el-input>
      </div>

      <!-- 踩点分数 --> 
      <div class="ti-score" v-if="type==99" :style="{'--myColor': myColor}" style="display: flex; gap: 2px;">
        <!-- <span :style="{color: myColor, fontSize: '30px', 'fontWeight': 'bold', display: 'inline'}">{{tiScore>0?"+"+tiScore:tiScore}}</span> -->
        <span :style="{color: myColor, fontSize: '35px', 'fontWeight': 'bold', display: 'inline'}">{{tiScore>0?"+"+tiScore:tiScore}}</span>
        <!--  实心加号： el-icon-circle-plus 实心减号： el-icon-remove  v-if="showScoreTool" -->
        <!-- <i class="el-icon-delete" style="display: inline;" @click.stop="changeScore(1)"></i> -->
        <div style="display: flex; flex-direction: column; gap: 3px; align-items: center; margin-top: -10px; ">
          <i class="el-icon-circle-close"  @click.stop="deleteMe()" style="color: #fe7984 ;font-size: 20px"></i>
          <i class="el-icon-circle-plus-outline"  @click.stop="changeScore(1)" style="color: #fe7984 ;font-size: 20px"></i>
          <i class="el-icon-remove-outline"   @click.stop="changeScore(-1)" style="color: #fe7984 ;font-size: 20px"></i>
        </div>
      </div>
    </div>

    <div class="quick-score" v-if="type==100 && !isShowPoint" :style="{'--myColor': myColor,height:'100%'}">
      <div class="topic-index" >{{other.topicIndex}}.</div>

      <div class="content-area" style="height: 100%; position: relative" >
        <div
          v-for="(item, index) in pointList"
          :key="index"
          class="num-label"
          :style="getMarkerStyle(item)"
        > 
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; margin-top: -20px; margin-left: -10px;">

        
          <span :style="{color: myColor, fontSize: '35px', 'fontWeight': 'bold', display: 'inline', }">{{item.score> 0 ? "+" + item.score: item.score}}</span>

          <div style="display: flex; flex-direction: column; gap: 3px; align-items: center; margin-top: -10px; margin-left: 5px; ">
            <i class="el-icon-circle-close"  @click.stop="deletePoint(index)" style="color: #fe7984 ;font-size: 20px" @mousedown.stop  @mouseup.stop></i>
            <i class="el-icon-circle-plus-outline"  @click.stop="changePoint(index,1)" style="color: #fe7984 ;font-size: 20px" @mousedown.stop  @mouseup.stop></i>
            <i class="el-icon-remove-outline"   @click.stop="changePoint(index,-1)" style="color: #fe7984 ;font-size: 20px" @mousedown.stop  @mouseup.stop></i>
          </div>

        </div>

        </div>
      </div>
    </div>

    <div class="quick-score" v-if="type==100  && isShowPoint" :style="{'--myColor': myColor}">
      <div class="topic-index">{{other.topicIndex}}.</div>
      <span :style="{color: myColor}" class="tip-score">{{tiScore>0?"+"+tiScore:tiScore}}</span>
    </div>



    
<!--    {{arrIdx}}({{x}},{{y}})-->
  </vue-drag-resize>

</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex';
  import VueDragResize from 'vue-drag-resize';

  export default {
    name: 'scorePoint',
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
      }),
    },
    data() {
      return {
        selectElement: '', myStyle: null, squareStyle: {width: '15px', height: '15px', border: '1px solid red' },
        theDialogVisible: true, wenziText: null, textStyle: {width: '80px'}, showScoreTool: false, isShowDelete: false,
        pw: 0, ph: 0, px: 0, py: 0, myColor: 'red',
        // 填空题踩点坐标列表
        pointList: [],

        // 辅助状态（鼠标判断用）
        isMousePressed: false,
        pressX: 0,
        pressY: 0,
        // 初始化拖拽框的位置(type=100)
        container: {
          width: this.w,
          height: this.h
        },
        originalSize: {
           width: this.w,
           height: this.h
          },
        myCanvas1Info: {},
        isShowPoint: false
      }
    },
    components:{
      VueDragResize
    },
    watch: {
      other: {
        handler(newVal) {
          // debugger
          // 判断是否是已阅状态,type=100 且不存在pointList
          let status = this.zgInfo.status
          let type = newVal.type
          let pointType = 'pointList'  in newVal
          // if(status == 'YY' && type == 100 && pointType){
          //   if (newVal?.pointList) {
          //     this.pointList = newVal.pointList;
          //   } else {
          //     this.pointList = [];
          //   }
          // }else 
          if(status == 'YY' && type == 100 && !pointType){
            // 已阅状态下的不存在pointList的
            this.isShowPoint = true
          }

          // 填空题踩点打分时，模拟拖拽更新位置信息
          // if(type == 100 && pointType){
            // debugger
            // this.simulateDrag()
          // }

          if (newVal?.pointList) {
              this.pointList = newVal.pointList;
            } else {
              this.pointList = [];
            }
          
        },
        deep: true,      // 深度监听
        immediate: true  // 立即执行一次（相当于 created 里的初始化）
      },
      type: {
        deep: true, immediate: true,
        handler(n, o) {
          if(n==4){
            console.log('this.other', this.other);
            this.wenziText = this.other.wenziText;
              this.textStyle = {width: this.w+'px'};
          }
        }
      },
      eColor: {
        deep: true, immediate: true,
        handler(n, o) {
          if(n){
            this.myColor = n;
          }else{
            this.myColor = 'red';
          }
        }
      }
    },
    props: {
      id: String,
      type: Number,
      arrIdx: Number,
      eColor: {
        type: String,
        default: 'red'
      },
      tiScore: {
        type: Number,
        required: false
      },
      caidianScore: {
        type: Number,
        required: false
      },
      other: {
        type: Object,
        required: false
      },
      h: {
        type: Number,
        default: 15,
      },
      w: {
        type: Number,
        default: 15,
      },
      zgInfo: {
          type: Object
      },
      x: Number,
      y: Number,
      isResizable: Boolean,
      isDraggable: Boolean
    },
    mounted(){
      // 获取区域
      // debugger
      // 获取画布1的实际高宽与对于div 的坐标信息
      this.myCanvas1Info = this.$el.parentElement.querySelector('#myCanvas1').getBoundingClientRect()
      this.$nextTick(() => {
        // 模拟调整大小事件
        this.simulateResize();
      });
    },
    created() {
      // 直接赋值
      // if (this.other && this.other.pointList) {
      //   debugger
      //   this.pointList = this.other.pointList
      //   console.log("scorePoint2 ====>");
      //   console.log(this.other.pointList);
      // }
    },
    
    methods: {
      myClick(e){
        console.log('point click', e, e.offsetX)
        this.$emit('select', this.id, this.arrIdx);
        if(this.type == 100){
          this.$emit('quickScore', this.id, this.arrIdx);
        }
        // let cn = e.target.className, offsetX = e.offsetX;
        //
        // if(cn == "topic-index"){
        //   this.changeScore(-0.5)
        // }else if(cn == "tip-score"){
        //   this.changeScore(0.5)
        // }else{
        //
        // }
      },
      resizeStop(newRect){
        console.log("resizestop", newRect)
      },
      dragstop(newRect){
        console.log("dragstop", newRect)
      },
      activateEv(){
        if(this.type == 4){
          this.$refs['drag-search'].focus();
        }
        if(this.type == 99){
          if(this.tiScore > 0) this.showScoreTool = true;
        }
      },
      deactivateEv(){
        if(this.type == 99){
          this.showScoreTool = false;
        }
      },
      weiziChange(e){
        this.$emit('repos', this.id, this.arrIdx, null, this.wenziText);
      },
      resize(newRect) {
        // debugger
        // console.log("调整------>", newRect)
        this.pw = newRect.width;
        this.ph = newRect.height;
        this.py = newRect.top;
        this.px = newRect.left;
        this.textStyle = {width: newRect.width+'px'};
        // console.log("newRect", this.textStyle);
        // 当状态为填空题的踩点打分时(type==100)
        if(this.type == 100){
          this.container.width =  newRect.width
          this.container.height =  newRect.height
          newRect.myCanvas1Info = this.myCanvas1Info
        }
        // debugger
        this.$emit('repos', this.id, this.arrIdx, newRect, this.wenziText);
      },
      dragging(newRect) {
        // debugger
        // console.log("拖拽------>", newRect)
        this.pw = newRect.width;
        this.ph = newRect.height;
        this.py = newRect.top;
        this.px = newRect.left;
        this.textStyle = {width: newRect.width+'px'};
        if(this.type == 100){
          newRect.myCanvas1Info = this.myCanvas1Info
        }
        // console.log("newRect", this.textStyle);
        this.$emit('repos', this.id, this.arrIdx, newRect, this.wenziText);
      },
      showDelete(v){
        this.isShowDelete = v
      },
      deleteMe(){
        console.log("deleteMe", this.id)
        this.$emit('deleteMe', this.id, this.arrIdx);
      },
      changeScore(v){
        let step = this.other.scoreStep;
        if(v < 0) step = 0 - this.other.scoreStep;
        let tiScore = this.tiScore + step;
        if(tiScore < 0) return;
        this.tiScore = tiScore;
        this.$emit('changeScore', this.id, this.arrIdx, this.tiScore, step);
      },
       // 鼠标按下方法：不变（仅记录状态，不添加逻辑）
       onMyMouseDown(e) {
          this.isMousePressed = true;
          this.pressX = e.clientX;
          this.pressY = e.clientY;
        },

        // 鼠标松开方法：核心改造，添加 isA 前置判断
        onMyMouseUp(e) {
          // 先重置鼠标按下状态
          this.isMousePressed = false;
          // 填空题踩点打分时利用鼠标的位移判断是移动还是点击
          if (this.type == 100) {
            // 1. 计算位移差
            let moveX = Math.abs(e.clientX - this.pressX);
            let moveY = Math.abs(e.clientY - this.pressY);
            // 2. 位移阈值
            let threshold = 2;
            // 3. 单纯点击判断
            let isPureClick = !this.isDragging && !this.isResizing && moveX < threshold && moveY < threshold;

            if (isPureClick) {
              this.handleClick(e.offsetX,e.offsetY)
            } else {
              console.log("拖拽/调整 标识");
            }
          } 

          // 侧边栏选中题序（标红）
          this.$emit('select', this.id, this.arrIdx);
          if(this.type == 100){
            console.log("quickScore ---- point");
            this.$emit('quickScore', this.id, this.arrIdx);
          }

          // 兜底：重置拖拽/调整状态，避免残留
          this.isDragging = false;
          this.isResizing = false;
        },

        getMarkerStyle(label) {
          // debugger
          let scaleX = this.container.width / this.originalSize.width
          let scaleY = this.container.height / this.originalSize.height
          
          // return {
          //   left: `${(pointList.x / this.originalSize.width) * 100}%`,
          //   top: `${(pointList.y / this.originalSize.height) * 100}%`,
          //   transform: `scale(${Math.min(scaleX, scaleY)})`
          // }

          // 填空题的标识位置是 容器内的百分比坐标，直接显示无需换算
          let leftPercent = label.x
          let topPercent = label.y
          return {
            left: `${leftPercent}%`,
            top: `${topPercent}%`,
          }
        },
        // 异步，鼠标的点击判断早于caidianScore(踩点步长值)的更新
        async handleClick(x,y) {
          // 等待 DOM 更新完成
          await this.$nextTick()

          console.log("quickScore ---- handleClick");
          // debugger
          // 判断踩点打分的分数总和是否超出总分，如果超出则不再插入(caidianScore允许切换)
          let pointItem = this.other
          let right = pointItem.rightScore
          // 当前打分分值
          let caidianScore = this.caidianScore
          // 当前已经批阅总分
          let total = this.pointList.reduce((sum, item) => sum + (item.score || 0), 0) + caidianScore
          if(total > right || total < 0){
            this.$message.error("点击分数不能超过满分或小于0分！")
            return 
          }else{
            
            // 百分比坐标位置(位置信息在拖拽区域内的百分比)
            // let percentX = (e.offsetX / this.container.width) * 100
            // let percentY = (e.offsetY / this.container.height) * 100

            let percentX = (x / this.container.width) * 100
            let percentY = (y / this.container.height) * 100

            // console.log("percentX===>",percentX);
            // console.log("percentY===>",percentY);
            
            // 拖拽边缘的标识
            if(percentX <= 0 || percentX >= 100 || percentY <= 0 || percentY >= 100) return


            // 仅单纯点击时添加 pointList
            this.pointList.push({
              // x: e.offsetX,
              // y: e.offsetY
              x: percentX,
              y:percentY,
              score: caidianScore
            });
            console.log("添加 标识 成功");
          }
          this.changeScoreByFill(total)
          // if(this.type == 100){
          //   console.log("quickScore ---- point");
          // debugger
          // this.$emit('quickScore', this.id, this.arrIdx,total);
          // }

        },
        // 删除填空题踩点打分的标识(type=100)
        deletePoint(index){
          this.pointList.splice(index, 1)
          // 删除后重新换算总分
          let total = this.pointList.reduce((sum, item) => sum + (item.score || 0), 0) 
          this.changeScoreByFill(total)

        },
        changePoint(index,value){
          // 判断加了之后会不会超出
          let pointItem = this.other
          let right = pointItem.rightScore
          let total = this.pointList.reduce((sum, item) => sum + (item.score || 0), 0) + value
          if(total > right || total < 0){
            this.$message.error("点击分数不能超过满分或小于0分！")
            return 
          }else{
            let newValue = this.pointList[index].score + value
            this.pointList[index].score = newValue
            this.$set(this.pointList[index], 'score', newValue)
          }
          this.changeScoreByFill(total)

        },
        // 填空题踩点打分(type == 100) 分数变动
        changeScoreByFill(total){
          // 保留pointList坐标
          this.$emit('changeCaiDianScore', this.id, this.arrIdx,total,this.pointList);
        },
        // 清空point
        // 填空题踩点打分-初始化时假装拖拽次窗口，对真实的位置信息进行更新
      //   simulateDrag() {
      //     // debugger
      //     // 构造当前的 newRect
      //     let currentRect = {
      //         left: this.x,
      //         top: this.y,
      //         width: this.w,
      //         height: this.h,
      //         right: this.x + this.w,
      //         bottom: this.y + this.h
      //     };
          
      //     // 直接调用 dragging 方法
      //     this.dragging(currentRect);
      // }
      simulateResize() {
        // debugger
        // 获取当前组件的尺寸和位置
        let currentRect = {
          width: this.w,
          height: this.h,
          top: this.y,
          left: this.x,
          myCanvas1Info: this.myCanvas1Info
        };

        // console.log("simulateResize =====>" ,this.id,currentRect);
        // 直接调用resize方法
        this.resize(currentRect);
        
        // 或者触发resizestop事件
        // this.resizeStop(currentRect);
      },
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

  .scorePoint {
    /*::v-deep .vdr .vdr.active:after{*/
    /*  outline: none;*/
    /*  background-color: #2a3542;*/
    /*}*/
    /*border: solid 1px red;*/
    z-index: 99;
    .div-del{
      position: absolute;
      right: -10px;
      top: -8px;
    }
    .div-del2{
      right: -10px;
      top: -15px;
    }
    .div-del4{
      right: 10px;
      top: -15px;
    }
    .div-del-inner{
      right: 40%;
      top: 40%;
    }
    .check {
      position: relative;
      display: inline-block;
      width: 40px;
      height: 40px;
      /*background: red;*/
      /*border-radius: 25px;*/
    }
    .check::after {
      content: "";
      position: absolute;
      left: 2px;
      top: 8px;
      // width: 80%;
      // height: 25%;
      // border: 4px solid var(--myColor);


      width: 90%; /* 增加宽度 */  
      height: 40%; /* 增加高度 */  
      border: 6px solid var(--myColor); /* 增加边框宽度 */  

      border-radius: 1px;
      border-top: none;
      border-right: none;
      background: transparent;
      transform: rotate(-45deg);
    }

    .check-hard {
      position: relative;
      display: inline-block;
      width: 40px;
      height: 40px;
      /*background: red;*/
      /*border-radius: 25px;*/
    }
    .check-hard::after {
      content: "";
      position: absolute;
      left: 2px;
      top: 8px;

      // width: 80%;
      // height: 25%;
      // border: 4px solid var(--myColor);

      width: 90%; /* 增加宽度 */  
      height: 40%; /* 增加高度 */  
      border: 6px solid var(--myColor); /* 增加边框宽度 */ 

      border-radius: 1px;
      border-top: none;
      border-right: none;
      background: transparent;
      transform: rotate(-45deg);
    }
    .check-hard::before {
      position: absolute;
      content: ' ';
      background-color: var(--myColor);
      // left: 12px;
      // top: 10px;
      // width: 4px;
      // height: 10px;
      left: 25px;
      top: 20px;
      width: 6px;
      height: 15px;
    }
    .check-hard::before {
      transform: rotate(-45deg);
    }
    //  横线
    .yi{
      background-color: var(--myColor);
      height: 2px;

      border: 1px solid var(--myColor); /* 增加边框宽度 */  

    }
    // 问号
      .wenhao{
          color: var(--myColor);
          // font-size: 36px;
          font-size: 56px;
          height: 36px;
      }
      // 省略号
      .shenglue{
          color: var(--myColor);
          // font-size: 36px;
          font-size: 56px;
          height: 16px;
      }
      // 叉
    .tick-error {
      position: relative;
      width: 40px;
      height: 40px;
    }
    .tick-error::before,
    .tick-error::after {
      position: absolute;
      content: ' ';
      background-color: var(--myColor);
      left: 18px;
      width: 3px;
      height: 40px;

      border: 2px solid var(--myColor); /* 增加边框宽度 */  

    }

    .tick-error::before {
      transform: rotate(45deg);
    }

    .tick-error::after {
      transform: rotate(-45deg);
    }
    // 文字
    .wenzi {
      width: 80px;
      input {color:var(--myColor);}

      .wenziTyle{
        // font-size: 18px;
        font-size: 24px;
        font-weight:900;
        color: var(--myColor);
        height: 40px;
        ::-webkit-input-placeholder {
          color: var(--myColor);
        }
        :-moz-placeholder {
          color: var(--myColor);
        }
        ::-moz-placeholder{
          color: var(--myColor);
        }
        :-ms-input-placeholder {
          color: var(--myColor);
        }
      }
    }
    .ti-score {


    }
    .quick-score{
      position: relative;
      .topic-index{
        position: absolute;
        left: 5px;
        top: 1px;
        font-size: 18px;
        color: red;
      }
      .tip-score{
        color: red;
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 20px;
        font-weight: bold;
        display: inline;
      }
    }
    //  圆形
    .ellipse{
      /*margin: 50px;*/
      background: transparent;
      // border: 2px solid var(--myColor);
      border-radius: 50% / 50%;

      border: 4px solid var(--myColor);
    }
    // 矩形
    .juxing{
      background: transparent;
      // border: 2px solid var(--myColor);
      
      border: 4px solid var(--myColor);
    }

  }
  .quickScore{
    // border: #1c6ca1 2px dotted;
    border: red 5px dotted;
  }
  .num-label {
    position: absolute;
    font-size: 16px;
    font-weight: bold;
    z-index: 10;
    cursor: pointer; /* 鼠标悬浮显示手型，提示可点击 */
  }

  .marker {
    position: absolute;
    width: 30px;
    height: 30px;
    background: #3498db;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    /* 加上 transition 让缩放更平滑 */
    transition: transform 0.2s;
  }



</style>
